export default __webpack_public_path__ + "static/media/searching.3d4d564e.gif";